import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Modal, message } from "antd";
import {
  ContinueBtn,
  PrinterPackslipBtn,
  PSPrinterModalWrapper,
  PSPrinterWrappers,
} from "./PSPrinterModal.style";
import PackSlipPrint from "../PackSlipPrint";
import { useState } from "react";
import {
  generateInvoicePdf,
  printPdfApi,
} from "../../../services/packslip.service";
import { selectPrinterByDesk } from "../../helper/deskData";
import { DEFAULT_DESK } from "../../../constants";

const PSPrinterModal = (props) => {
  const { currDesk, deskData, boxNumber } = props;
  const [tempInvoiceLink, setTempInvoiceLink] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [loading, toggleLoading] = useState(false);

  const handleContinue = () => {
    window.location.reload();
  };

  const handlePrint = async () => {
    try {
      if (!currDesk) {
        message.error("Please select a desk to print the invoice", 2);
      } else {
        toggleLoading(true);

        const { responseData: invoiceGenerated } = await generateInvoicePdf({
          boxNumber,
        });

        if (invoiceGenerated) {
          setShowPreview(true);
          setTempInvoiceLink(invoiceGenerated);
          toggleLoading(false);

          let printerDetails = {
            printerId: selectPrinterByDesk(deskData, currDesk),
            contentType: "pdf_uri",
            content: invoiceGenerated,
            title: boxNumber + " - Invoice",
            source: "Checker",
          };

          await printPdfApi(printerDetails);
          message.success("Done");
        }
      }
    } catch (error) {
      message.error(error.message || "Internal Server Error");
      toggleLoading(false);
    }
  };

  return (
    <>
      <PSPrinterWrappers>
        <Modal
          title={`Container Packaging Done`}
          open={props.isPrintModalOpen}
          footer={null}
          cancelButtonProps={{
            disabled: loading,
          }}
          closable={false}
        >
          <PSPrinterModalWrapper>
            <PrinterPackslipBtn onClick={handlePrint} disabled={loading}>
              Print Packslip
            </PrinterPackslipBtn>
            <ContinueBtn onClick={handleContinue} disabled={loading}>
              Continue
            </ContinueBtn>
          </PSPrinterModalWrapper>
        </Modal>
      </PSPrinterWrappers>
      <PackSlipPrint
        showPreview={showPreview}
        closePreview={() => {
          setShowPreview(false);
          window.location.reload();
        }}
        tempInvoiceLink={tempInvoiceLink}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.LoaderReducer?.isLoading,
  deskData: state.newCheckerOrderReducer.deskDetails?.deskDetailsList,
  currDesk: state.statusReducer?.deskNumber || DEFAULT_DESK,
  userRole: state.authReducer?.AuthData?.userDTO.role,
  isOnline: state.statusReducer?.isOnline,
});

export default withRouter(connect(mapStateToProps, null)(PSPrinterModal));
